(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gali-story-assets"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const link=event.target.closest('[data-gali-cta]');if(!link)return;const main=document.getElementById('gali-purchase')||document.querySelector('product-form-component');if(main){event.preventDefault();main.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});main.setAttribute('tabindex','-1');main.focus({preventScroll:true});}});
document.addEventListener('click',function(event){
  var btn = event.target.closest('.gali-carousel-btn');
  if(!btn) return;
  var target = document.getElementById(btn.getAttribute('data-target'));
  if(!target) return;
  var card = target.querySelector('.gali-card');
  var amount = card ? (card.getBoundingClientRect().width + 16) : (target.clientWidth * 0.85);
  var dir = btn.classList.contains('gali-carousel-next') ? -amount : amount;
  target.scrollBy({ left: dir, behavior: 'smooth' });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ob-home-scripts"] && !Shopify.designMode) return;
  try {
    (function () {
  const tilt = () => {
    if (!matchMedia('(hover: hover) and (pointer: fine)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.ob-home--card .ob-home__split').forEach(card => {
      if (card.dataset.obTilt) return;
      card.dataset.obTilt = '1';
      let frame;
      card.addEventListener('pointermove', e => {
        if (document.querySelector('.ob-motion-paused')) return;
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          card.style.setProperty('--ry', (x * 6).toFixed(2) + 'deg');
          card.style.setProperty('--rx', (y * -4).toFixed(2) + 'deg');
          card.style.setProperty('--gx', ((x + 0.5) * 100).toFixed(1) + '%');
          card.style.setProperty('--gy', ((y + 0.5) * 100).toFixed(1) + '%');
        });
      });
      card.addEventListener('pointerleave', () => {
        cancelAnimationFrame(frame);
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tilt); else tilt();
  document.addEventListener('shopify:section:load', tilt);
})();
if (!customElements.get('ob-home-carousel')) {
  customElements.define('ob-home-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-direction]');
        if (!button) return;
        const rail = this.querySelector('.ob-home__rail');
        const rtl = getComputedStyle(rail).direction === 'rtl';
        const step = rail.querySelector('a').getBoundingClientRect().width + 24;
        rail.scrollBy({left: step * (button.dataset.direction === 'next' ? 1 : -1) * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ob-lazy-video"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.obLazyVideo) return;
  window.obLazyVideo = true;

  function load(v) {
    if (v.dataset.loaded || !v.dataset.src) return;
    v.dataset.loaded = '1';
    if (v.dataset.fallback) {
      v.addEventListener('error', function () {
        if (!v.dataset.fallback || v.dataset.usedFallback) return;
        v.dataset.usedFallback = '1';
        v.src = v.dataset.fallback;
        v.load();
        if (v.dataset.visible) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    }
    v.src = v.dataset.src;
    v.preload = 'auto';
    v.load();
  }
  function play(v) {
    load(v);
    v.muted = true;
    v.dataset.visible = '1';
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  var near = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { load(e.target); near.unobserve(e.target); } });
  }, { rootMargin: '400px 0px' }) : null;

  var seen = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) play(e.target);
      else { delete e.target.dataset.visible; e.target.pause(); }
    });
  }, { threshold: 0.25 }) : null;

  function init(scope) {
    (scope || document).querySelectorAll('video.ob-lazy-video').forEach(function (v) {
      if (v.dataset.obWatched) return;
      v.dataset.obWatched = '1';
      if (!near) { play(v); return; }
      near.observe(v);
      seen.observe(v);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
  } catch(e) { console.error(e); }
})();

})();
